import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(
  tableAnatomy.keys,
);

const simple = definePartsStyle({
  table: {
    borderColor: 'border.muted',
  },
  thead: {
    th: {
      bg: 'bg.subtle',
      color: 'text.primary',
      borderColor: 'border.muted',
      fontWeight: 'medium',
    },
  },
  tbody: {
    tr: {
      transitionProperty: 'background-color',
      transitionDuration: 'normal',
      _even: {
        bg: 'bg.subtle',
      },
      _hover: {
        bg: 'bg.subtle.hover',
      },
    },
  },
  th: {
    borderColor: 'border.muted',
  },
  td: {
    borderColor: 'border.muted',
  },
  tfoot: {
    tr: {
      borderColor: 'border.muted',
    },
  },
});

const striped = definePartsStyle({
  table: {
    borderColor: 'border.muted',
  },
  thead: {
    th: {
      bg: 'bg.subtle',
      color: 'text.primary',
      borderColor: 'border.muted',
      fontWeight: 'medium',
    },
  },
  tbody: {
    tr: {
      '&:nth-of-type(odd)': {
        bg: 'bg.input',
      },
      '&:nth-of-type(even)': {
        bg: 'bg.subtle',
      },
      _hover: {
        bg: 'bg.subtle.hover',
      },
    },
  },
  th: {
    borderColor: 'border.muted',
  },
  td: {
    borderColor: 'border.muted',
  },
});

export const Table = defineMultiStyleConfig({
  variants: {
    simple,
    striped,
  },
  defaultProps: {
    variant: 'simple',
  },
});
